// src/components/infografia/modals/IconSelectorModal.jsx
import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';
import * as HiIcons from 'react-icons/hi';
import * as IoIcons from 'react-icons/io5';

const ICON_LIBRARIES = [
    { name: 'Font Awesome', icons: FaIcons, prefix: 'Fa' },
    { name: 'Material Design', icons: MdIcons, prefix: 'Md' },
    { name: 'Heroicons', icons: HiIcons, prefix: 'Hi' },
    { name: 'Ionicons', icons: IoIcons, prefix: 'Io' }
];

// Iconos populares pre-seleccionados
const POPULAR_ICONS = [
    'FaUser', 'FaHome', 'FaHeart', 'FaStar', 'FaShoppingCart',
    'FaEnvelope', 'FaPhone', 'FaMapMarkerAlt', 'FaCalendar',
    'FaClock', 'FaSearch', 'FaBell', 'FaCog', 'FaImage',
    'FaMusic', 'FaVideo', 'FaCamera', 'FaGift', 'FaTag',
    'MdFavorite', 'MdLocationOn', 'MdEmail', 'MdPhone',
    'HiHeart', 'HiStar', 'HiHome', 'HiUser', 'HiShoppingBag',
    'IoHeart', 'IoStar', 'IoHome', 'IoPerson'
];

const IconSelectorModal = ({ isOpen, onClose, onSelectIcon }) => {
    const [selectedLibrary, setSelectedLibrary] = useState('Font Awesome');
    const [searchQuery, setSearchQuery] = useState('');
    const [showPopular, setShowPopular] = useState(true);

    const getCurrentLibrary = () => {
        return ICON_LIBRARIES.find(lib => lib.name === selectedLibrary);
    };

    const getAvailableIcons = () => {
        const library = getCurrentLibrary();
        if (!library) return [];

        const iconEntries = Object.entries(library.icons);

        if (showPopular && !searchQuery) {
            // Mostrar iconos populares primero
            const popular = iconEntries.filter(([name]) =>
                POPULAR_ICONS.includes(name)
            );
            const others = iconEntries.filter(([name]) =>
                !POPULAR_ICONS.includes(name)
            );
            return [...popular, ...others];
        }

        if (searchQuery) {
            return iconEntries.filter(([name]) =>
                name.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        return iconEntries;
    };

    const handleSelectIcon = (iconName) => {
        const library = getCurrentLibrary();
        const IconComponent = library.icons[iconName];
        if (IconComponent) {
            onSelectIcon({
                name: iconName,
                library: library.name,
                component: IconComponent,
                prefix: library.prefix
            });
            onClose();
        }
    };

    if (!isOpen) return null;

    const icons = getAvailableIcons();

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <h2 className="text-2xl font-semibold text-gray-900">Seleccionar Icono</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600"
                    >
                        <FaTimes className="text-2xl" />
                    </button>
                </div>

                {/* Library Selector */}
                <div className="p-4 border-b border-gray-200">
                    <div className="flex gap-2 mb-4">
                        {ICON_LIBRARIES.map((lib) => (
                            <button
                                key={lib.name}
                                onClick={() => {
                                    setSelectedLibrary(lib.name);
                                    setSearchQuery('');
                                }}
                                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${selectedLibrary === lib.name
                                        ? 'bg-blue-500 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                    }`}
                            >
                                {lib.name}
                            </button>
                        ))}
                    </div>

                    {/* Search */}
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => {
                            setSearchQuery(e.target.value);
                            setShowPopular(false);
                        }}
                        placeholder="Buscar icono..."
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>

                {/* Icons Grid */}
                <div className="flex-1 overflow-y-auto p-6">
                    <div className="grid grid-cols-6 md:grid-cols-8 lg:grid-cols-10 gap-4">
                        {icons.map(([iconName, IconComponent]) => (
                            <button
                                key={iconName}
                                onClick={() => handleSelectIcon(iconName)}
                                className="flex flex-col items-center justify-center p-4 border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all group"
                                title={iconName}
                            >
                                <IconComponent className="text-2xl text-gray-700 group-hover:text-blue-600" />
                                <span className="text-xs text-gray-500 mt-2 truncate w-full text-center">
                                    {iconName.replace(getCurrentLibrary().prefix, '')}
                                </span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IconSelectorModal;

